import React from 'react';
import { Section } from './Section';
import { Countdown } from './Countdown';
import { REGULAR_PRICE, SPOTS_TAKEN_PERCENT } from '../lib/config';

/**
 * ⚠️ La ventana se configura en lib/config.ts → COUNTDOWN_WINDOW_HOURS (12 horas).
 * El deadline es el mismo para todos los visitantes; debe corresponder a una suba
 * de precio efectivamente programada.
 */
export function Urgency() {
  return <Section tone="ink" data-id="element-251" data-mp="1o6jug6ytxsk9">
      <div className="flex flex-col items-center text-center" data-id="element-252" data-mp="1o6biqieg0tan">
        <p className="kicker" data-id="element-253" data-mp="1sxjuhl38wqqz">Precio de lanzamiento — termina en</p>

        <div className="mt-7" data-id="element-254" data-mp="1szwf660e1f7q">
          <Countdown tone="dark" data-id="element-255" data-mp="1e9fhmxqvj9g4" />
        </div>

        <p className="mt-7 text-sm text-ivory/70" data-id="element-256" data-mp="1eaqml0w22n8t">
          Después vuelve al precio regular de {REGULAR_PRICE}.
        </p>

        <div className="mt-10 w-full max-w-[440px]" data-id="element-257" data-mp="1587kij03genm">
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuenow={SPOTS_TAKEN_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos a precio de lanzamiento ya tomados" data-id="element-258" data-mp="159ilyc62habk">
            <div className="h-full bg-gold-grad" style={{
            width: `${SPOTS_TAKEN_PERCENT}%`
          }} data-id="element-259" data-mp="20zo0mk4kxanh" />
          </div>
          <p className="mt-3 text-xs uppercase tracking-[0.14em] text-ivory/50" data-id="element-260" data-mp="2axty8pjcrumj">
            {SPOTS_TAKEN_PERCENT}% de los cupos a precio de lanzamiento ya
            tomados
          </p>
        </div>
      </div>
    </Section>;
}